module.exports = __webpack_public_path__ + "img/mk.ed091b88.svg";